// extracted by mini-css-extract-plugin
export default {"root":"PaypalPaymentInProgressPanel_root__STaXU","label":"PaypalPaymentInProgressPanel_label__crAet"};